import { render, staticRenderFns } from "./applyAuthorizationVouchersDrawer.vue?vue&type=template&id=19874b28&scoped=true"
import script from "./applyAuthorizationVouchersDrawer.vue?vue&type=script&lang=js"
export * from "./applyAuthorizationVouchersDrawer.vue?vue&type=script&lang=js"
import style0 from "./applyAuthorizationVouchersDrawer.vue?vue&type=style&index=0&id=19874b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19874b28",
  null
  
)

export default component.exports